import CompanyCard from "./CompanyCard";

/**
 * The featured strip at the top of Explore Companies.
 *
 * Same card as every other row, three across. It used to have a card of its
 * own - logo, description, "CoS Issued", "Verified Jobs" - which meant one
 * page carried two card designs and two vocabularies for the same facts.
 * The API now returns featured companies in the directory row shape, so
 * there is nothing to translate here.
 *
 * The page hides this block whenever a filter is active: a strip of
 * unrelated promoted companies sitting above a filtered result reads as
 * though it is part of the result.
 */
export default function FeaturedCompanies({ content, featured_companies }) {
  if (!featured_companies || featured_companies.length === 0) return null;

  return (
    <div className="feature_companies_wrapper">
      <div className="top_head">
        <div className="text">
          <h3>{content?.featured_heading}</h3>
          <p>{content?.featured_tagline}</p>
        </div>
      </div>
      <div className="row form_row">
        {featured_companies.map((company, i) => (
          <div
            className="col-md-4 d-flex"
            key={`${company.id ?? "f"}-${company.name}-${i}`}
          >
            <CompanyCard company={company} />
          </div>
        ))}
      </div>
    </div>
  );
}
